import type { DialogProps } from '@montugroup/design-system';
import { Box, Dialog, DialogContent, IconButton } from '@montugroup/design-system';
import CloseIcon from '@mui/icons-material/Close';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

export default function EnquiryDialog({
  children,
  open,
  onClose,
}: Pick<DialogProps, 'open' | 'children'> & { onClose?: () => void }) {
  const theme = useTheme();

  const isSmDown = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Dialog open={open} fullScreen={isSmDown} onClose={onClose}>
      {onClose && (
        <Box textAlign="right">
          <IconButton aria-label="close" onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Box>
      )}
      <DialogContent>{children}</DialogContent>
    </Dialog>
  );
}
